import React from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import useMonitorAlerts from '../hooks/useMonitorAlerts';
import useMonitorAlertsEnabled from '../hooks/useMonitorAlertsEnabled';
import { TRANSLATION_KEY } from '../constants';
import { countKey } from '../utils';
import css from './MonitorAlertsNavIndicator.css';

const NAV_KEY = `${TRANSLATION_KEY}.NAV`;

export const NAV_INDICATOR_VARIANTS = {
    COUNT: 'count',
    DOT: 'dot',
    SECTION_DOT: 'sectionDot',
};

// Rendered as its own element rather than through the sidenav's getSectionTag, which
// returns only the first matching tag and is already spoken for by AI Lab's "New".
const MonitorAlertsNavIndicator = ({ variant = NAV_INDICATOR_VARIANTS.DOT, translate }) => {
    const enabled = useMonitorAlertsEnabled();
    const { unreadAttentionCount } = useMonitorAlerts();

    if (!enabled || unreadAttentionCount === 0) return null;

    // Decorative: the AI Lab row above this one is showing the same unread state, and
    // announcing it here would report it twice.
    if (variant === NAV_INDICATOR_VARIANTS.DOT) return <span aria-hidden="true" className={css.dot} />;

    return (
        <span
            role="status"
            aria-label={translate(`${NAV_KEY}.${countKey('ATTENTION', unreadAttentionCount)}`, {
                count: unreadAttentionCount,
            })}
            className={css[variant]}
        >
            {variant === NAV_INDICATOR_VARIANTS.COUNT ? unreadAttentionCount : null}
        </span>
    );
};

MonitorAlertsNavIndicator.propTypes = {
    variant: PropTypes.oneOf(Object.values(NAV_INDICATOR_VARIANTS)),
    translate: PropTypes.func.isRequired,
};

export default withLocalize(MonitorAlertsNavIndicator);
